<template>
    <div>
        <div class="title__rank">
            <span v-text="t.bonus"></span>
        </div>
        <div class="card-v4">
            <div class="subcard-v4" v-if="!isAmbassador">
                <div class="card__row">
                    <div class="bonus__retention">
                        <span class="helper__tooltip">
                            <h2 class="value__title" v-text="t.dash_business_retention_bonus"></h2>
                            <span
                                class="helper__tooltip--text"
                                v-html="t.tooltip_retention_bonus_v4"
                            ></span>
                        </span>
                        <div class="charts__container">
                            <div class="chart">
                                <radial-progress-v4
                                    :options="{
                                        color : '#0266FF',
                                        step  : values2Bind.retention_bonus_num_leads.cycle_1
                                    }"
                                    :client="t.office2_ganhos_cliente"
                                ></radial-progress-v4>
                                <span v-text="t.dash_business_label_radial_graph_one"></span>
                            </div>
                            <div class="chart">
                                <radial-progress-v4
                                    :options="{
                                        color : '#30D2D6',
                                        step  : values2Bind.retention_bonus_num_leads.cycle_2
                                    }"
                                    :client="t.office2_ganhos_cliente"
                                ></radial-progress-v4>
                                <span v-text="t.dash_business_label_radial_graph_two"></span>
                            </div>
                            <div class="chart">
                                <radial-progress-v4
                                    :options="{
                                        color : '#4988A6',
                                        step  : values2Bind.retention_bonus_num_leads.cycle_3
                                    }"
                                    :client="t.office2_ganhos_cliente"
                                ></radial-progress-v4>
                                <span v-text="t.dash_business_label_radial_graph_three"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card__row">
                    <div class="container__gains">
                        <div class="box__type">
                            <h3 v-html="t.bonus_retention_paid"></h3>
                            <div class="dash__value" v-html="retention_paid"></div>
                        </div>
                        <div class="box__type">
                            <h3 v-html="t.bonus_retention_paid_estimated"></h3>
                            <div class="dash__value" v-html="retention_estimated"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "retention-bonus-v4",
    data() {
        return {
            retention_paid: "",
            retention_estimated: "",
            t: this.$parent.view.translation.retention_bonus,
            values2Bind: this.$parent.view.dashboard_values_v3,
            isAmbassador:
                this.$parent.view.IS_AMBASSADOR ||
                this.$parent.view.IS_AMBASSADOR_PLUS
                    ? true
                    : false
        };
    },

    methods: {
        mountValues(usd, brl, eur, btc) {
            // return `
            //     <p> <span>USD</span> <span>$ ${usd}</span> </p>
            //     <p> <span>BRL</span> <span>&euro; ${brl}</span> </p>
            //     <p> <span>EUR</span> <span>R$ ${eur}</span> </p>
            //     <p> <span>BTC</span> <span><i class="fa fa-btc"></i> ${btc}</span> </p>
            // `;
            return `
                <p> <span>USD</span> <span>$ ${usd}</span> </p>
                <p> <span>EUR</span> <span>&euro; ${eur}</span> </p>
            `;
        },

        handleJsonValues() {
            // console.log(this.props);
            this.retention_paid = this.mountValues(
                //se existe a chave ele inclui o valor se nao passa 0
                this.values2Bind.total_retention_bonus_paid.USD
                    ? this.values2Bind.total_retention_bonus_paid.USD
                    : 0,
                this.values2Bind.total_retention_bonus_paid.BRL
                    ? this.values2Bind.total_retention_bonus_paid.BRL
                    : 0,
                this.values2Bind.total_retention_bonus_paid.EUR
                    ? this.values2Bind.total_retention_bonus_paid.EUR
                    : 0,
                this.values2Bind.total_retention_bonus_paid.BTC
                    ? this.values2Bind.total_retention_bonus_paid.BTC
                    : 0
            );
            this.retention_estimated = this.mountValues(
                this.values2Bind.retention_bonus_estimated_next_month.USD
                    ? this.values2Bind.retention_bonus_estimated_next_month.USD
                    : 0,
                this.values2Bind.retention_bonus_estimated_next_month.BRL
                    ? this.values2Bind.retention_bonus_estimated_next_month.BRL
                    : 0,
                this.values2Bind.retention_bonus_estimated_next_month.EUR
                    ? this.values2Bind.retention_bonus_estimated_next_month.EUR
                    : 0,
                this.values2Bind.retention_bonus_estimated_next_month.BTC
                    ? this.values2Bind.retention_bonus_estimated_next_month.BTC
                    : 0
            );
        }
    },

    mounted() {
        this.handleJsonValues();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$break-x-large: 1450px;
$break-large: 1200px;
$break-medium: 980px;
$break-tablet: 768px;
$break-small: 575px;

.retention__bonus {
    margin-top: 2rem;
    .card-v4 {
        margin-bottom: 0;
        border-bottom: none;
        border-radius: 0;
        .subcard-v4 {
            border: 1px solid #dadada;
            border-radius: 8px;
            .card__row {
                padding: 1rem 1rem 2rem 1rem;
                .bonus__retention {
                    text-align: center;
                    .helper__tooltip {
                        margin-bottom: 1rem;
                        .helper__tooltip--text {
                            text-align: center;
                            line-height: 21px;
                            text-align: left;
                        }
                    }
                    h2 {
                        font-weight: bold;
                        font-size: 1.15rem;
                    }
                    .charts__container {
                        display: grid;
                        grid-template-columns: 1fr 1fr 1fr;
                        grid-gap: 1rem;
                        text-align: center;
                        align-items: end;

                        @media (max-width: $break-medium) {
                            grid-template-columns: 1fr;
                            div.chart {
                                border-bottom: 1px solid #eee;
                                &:nth-child(2) {
                                    border-left: none !important;
                                    border-right: none !important;
                                }
                            }
                        }

                        div.chart {
                            padding: 1rem;
                            &:nth-child(2) {
                                border-left: 1px solid #eee;
                                border-right: 1px solid #eee;
                            }
                        }
                        span {
                            font-size: 0.8rem;
                            color: #707070;
                            line-height: 3rem;
                        }
                    }
                }

                .container__gains {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    justify-items: center;
                    gap: 2rem;
                    margin-top: 1rem;

                    @media (max-width: $break-medium) {
                        grid-template-columns: 1fr;
                    }

                    .box__type {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;

                        &:first-child {
                            border-right: 1px solid #edf0f5;
                            @media (max-width: $break-tablet) {
                                border: none;
                            }
                        }
                        h3 {
                            color: #707070;
                            font-weight: normal;
                            text-transform: uppercase;
                            font-size: 1.1rem;
                            text-align: center;
                            margin-bottom: 2rem;
                            max-width: 300px;
                            line-height: 1.5rem;
                        }
                        .dash__value {
                            min-width: 247px;
                            margin: 0 auto;
                            border: 1px solid #dadada;
                            border-radius: 8px;
                            padding: 1.5rem 0.7rem;
                            @media (max-width: $break-small) {
                                min-width: 100%;
                            }
                        }
                    }
                }
            }
        }
    }
}

.helper__tooltip::after {
    width: 26px;
    height: 26px;
    top: 58%;
    right: -48px;
    background-image: url("data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12.5' cy='12.5' r='12.5' fill='%237E1AFD'/%3E%3Cpath d='M10.408 7.104C11.0907 6.688 11.8853 6.48 12.792 6.48C13.4533 6.48 14.04 6.592 14.552 6.816C15.064 7.04 15.4587 7.34933 15.736 7.744C16.024 8.13867 16.168 8.59733 16.168 9.12C16.168 9.68533 16.0347 10.1707 15.768 10.576C15.512 10.9813 15.1227 11.4507 14.6 11.984C14.1627 12.432 13.832 12.816 13.608 13.136C13.384 13.4453 13.2453 13.7973 13.192 14.192L13.128 14.64H11.944V13.984C11.944 13.3867 12.0507 12.8853 12.264 12.48C12.4773 12.064 12.7867 11.616 13.192 11.136C13.5013 10.7733 13.7307 10.4587 13.88 10.192C14.04 9.92533 14.12 9.62667 14.12 9.296C14.12 8.92267 13.9867 8.63467 13.72 8.432C13.464 8.21867 13.1067 8.112 12.648 8.112C11.9013 8.112 11.1547 8.34133 10.408 8.8V7.104ZM11.432 15.76H13.688V18H11.432V15.76Z' fill='white'/%3E%3C/svg%3E%0A");
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/retentionBonus.vue